import React from 'react';
import Hero from './Hero';
import MarketingSection from './MarketingSection';
import SmarterAds from './SmarterAds';
import AppDevelopment from './AppDevelopment';
import DigitalMarketing from './DigitalMarketing';
import ClientReviews from './ClientReviews';

const Home = () => {
  return (
    <div>
      <Hero />
      <MarketingSection />
      <SmarterAds />
      <AppDevelopment />
      <DigitalMarketing />
      <ClientReviews />
    </div>
  );
};

export default Home;
